<template>
  <fin-elevated-box :padding-px="8" :padding-py="4" class="portfolio-value-box" hard-shadow>
    <fin-lexicon-text auto-solve class="portfolio-value-box__title" :text="title"/>

    <slot name="actions"/>

    <div>
      <div>
        <slot name="contentPrepend"/>
      </div>

      <div>
        <div class="portfolio-value-box__value"
             :style="{color: color ? color : valueLineColor}"
             v-if="!hideValueLine">
          <slot name="valueLine">{{ valueLine | percent | isNaN }}</slot>
        </div>

        <div class="portfolio-value-box__hint mt-1" v-if="!hideHint && hint">
          <slot name="hint">
            <fin-lexicon-text auto-solve :text="hint"/>
          </slot>
        </div>

        <div :style="{color: subValueLineColor}"
             class="portfolio-value-box__diff"
             v-if="!hideValueSubline">
          <slot name="valueSubline">{{ valueSubline | percent }}</slot>
        </div>
      </div>
    </div>

    <slot name="buttons"/>
  </fin-elevated-box>
</template>

<script>
import FinElevatedBox from "@/components/common/box/elevatedBox"
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  name: 'FinPortfolioValue',
  components: {FinLexiconText, FinElevatedBox},
  props: {
    hideValueLine: {
      type: Boolean,
      default: false
    },
    hideValueSubline: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    hint: {
      type: String
    },
    hideHint: {
      type: Boolean,
      default: false
    },
    valueLine: {
      type: Number
    },
    valueSubline: {
      type: Number
    },
    color: {
      type: String
    },
  },
  computed: {
    valueLineColor() {
      let result

      // Round to 2 decimal places
      let value = Math.round(this.valueLine * 100) / 100

      if (value >= 0) {
        result = this.$finColors.accentGreen
      } else if (value < 0) {
        result = this.$finColors.accentRed
      } else {
        result = this.$finColors.primaryColor
      }

      return result
    },
    subValueLineColor() {
      let result
      if (this.color) {
        result = this.color
      } else if (this.valueSubline < 0) {
        result = this.$finColors.accentRed
      } else {
        result = this.$finColors.accentGreen
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables.scss";

.portfolio-value-box {
  height: 100%;
}

.portfolio-value-box__title {
  font-family: $body-font-family;
  font-size: 0.9em;
  text-transform: uppercase !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-primary-dark;
}

.portfolio-value-box__hint {
  font-family: $body-font-family;
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-cool-grey;
}

.portfolio-value-box__value {
  font-family: $body-font-family;
  font-size: 3em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  /* additional styling */
  min-height: 38px;

  @media screen and (max-width: 1264px) {
    font-size: 2.2em;
  }
  @media screen and (max-width: 960px) {
    font-size: 2em;
  }
}

.portfolio-value-box__diff {
  font-family: $body-font-family;
  font-size: 1.3em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  /* additional styling */
  min-height: 21px;
}
</style>
